import hackerrank from "./../resources/social-icon/Hackerrank.png";

const certificates = [
  {
    certificateId: "7639BE59E9EF",
    providerIcon: hackerrank,
    title: "Java (Basic)",
    link: "https://www.hackerrank.com/certificates/7639be59e9ef",
    imageUrl:
      "https://github.com/jaymanale/Official-Website-Version-2/assets/5653906/b4d38109-8835-445d-958d-44b554531ab8",
  },
  {
    certificateId: "6F0ECC5C89C8",
    providerIcon: hackerrank,
    title: "Javascript (Basic)",
    link: "https://www.hackerrank.com/certificates/6f0ecc5c89c8",
    imageUrl:
      "https://github.com/jaymanale/Official-Website-Version-2/assets/5653906/bc02cc6c-f22a-48c6-bb15-f50917f612d6",
  },
  {
    certificateId: "99630BB6F503",
    providerIcon: hackerrank,
    title: "Problem Solving (Basic)",
    link: "https://www.hackerrank.com/certificates/99630bb6f503",
    imageUrl:
      "https://github.com/jaymanale/Official-Website-Version-2/assets/5653906/9fdea2bc-574c-40f0-b4c6-934175bd42db",
  },
  {
    certificateId: "61FBF9BD2BDA",
    providerIcon: hackerrank,
    title: "SQL (Intermediate)",
    link: "https://www.hackerrank.com/certificates/61fbf9bd2bda",
    imageUrl:
      "https://github.com/jaymanale/Official-Website-Version-2/assets/5653906/8a0c3160-09b4-4094-b09c-708f5b0fa8ba",
  },
  {
    certificateId: "93011046C88C",
    providerIcon: hackerrank,
    title: "SQL (Basic)",
    link: "https://www.hackerrank.com/certificates/93011046c88c",
    imageUrl:
      "https://github.com/jaymanale/Official-Website-Version-2/assets/5653906/3245a9d5-0903-4eb8-b9b8-1b9661b2b21a",
  },
];

const getCertificatesData = () => {
  return certificates;
};

export default getCertificatesData;
